import {
  MultipleComboboxApiConfig,
  MultipleComboboxItem,
} from "@/components/forms/form-multiple-combobox-async";
import { ShopList, ShopItem } from "@/hooks/services/pps/handlers/shop-api";
import { ProcessList } from "@/hooks/services/pps/handlers/process-api";
import { TechnicianList } from "@/hooks/services/pps/handlers/technicians-api";

export const shopSearchApiConfig: MultipleComboboxApiConfig = {
  apiFunction: ShopList,
  searchParams: (searchText: string) => ({
    search: searchText,
  }),
  dataPath: "data",
  mapToItem: (shop: ShopItem): MultipleComboboxItem => ({
    id: shop.id,
    label: shop.shopName,
    value: shop.id,
    subtitle: "",
    raw: shop,
  }),
};

export const processSearchApiConfig: MultipleComboboxApiConfig = {
  apiFunction: ProcessList,
  searchParams: (searchText: string, additionalParams?: any) => ({
    search: searchText,
    page: 1,
    pageSize: 20,
    ...(additionalParams?.shopId && { shopId: additionalParams.shopId }),
  }),
  dataPath: "data",
  mapToItem: (process: any): MultipleComboboxItem => ({
    id: process.id,
    label: process.processName || process.name,
    value: process.id,
    subtitle: process.processCode || "",
    raw: process,
  }),
};

export const technicianSearchApiConfig: MultipleComboboxApiConfig = {
  apiFunction: TechnicianList,
  searchParams: (searchText: string, additionalParams?: any) => ({
    search: searchText,
    page: 1,
    pageSize: 20,
    workspaceId: additionalParams?.workspaceId || null,
    ...(additionalParams?.shopId && { shopId: additionalParams.shopId }),
  }),
  dataPath: "data",
  mapToItem: (technician: any): MultipleComboboxItem => ({
    id: technician.id,
    label: technician.name,
    value: technician.id,
    subtitle: technician.machineId || "",
    raw: technician,
  }),
};

// Multi-select version for technicians
export const technicianMultipleApiConfig: MultipleComboboxApiConfig = {
  apiFunction: TechnicianList,
  searchParams: (searchText: string, additionalParams?: any) => ({
    search: searchText,
    page: 1,
    pageSize: 20,
    workspaceId: additionalParams?.workspaceId || null,
    ...(additionalParams?.shopId && { shopId: additionalParams.shopId }),
  }),
  dataPath: "data",
  mapToItem: (technician: any): MultipleComboboxItem => ({
    id: technician.id,
    label: technician.name,
    value: technician.id,
    subtitle: technician.machineId || "",
    raw: technician,
  }),
};
